import { wsService } from "../wsService";

const section = "mercadopago";

function createPreference(param = {}) {
    return wsService.make_post_request(section + "/create-preference", param);
  
}

export const mpService = {
  section,
  createPreference,
};
